import { render, staticRenderFns } from "./cModalOtrosIngresos.vue?vue&type=template&id=66b96141&scoped=true"
import script from "./cModalOtrosIngresos.vue?vue&type=script&lang=js"
export * from "./cModalOtrosIngresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b96141",
  null
  
)

export default component.exports